/**
 * Converts a string to start case.
 * Similar to Lodash's startCase function but without dependencies.
 * Capitalizes the first letter of each word and replaces special characters with spaces.
 *
 * @param str - The string to convert to start case
 * @returns The start cased string
 *
 * @example
 * startCase('foo_bar')     // 'Foo Bar'
 * startCase('fooBar')      // 'Foo Bar'
 * startCase('--foo-bar--') // 'Foo Bar'
 * startCase('__FOO_BAR__') // 'FOO BAR'
 */
export const startCase = (str: string): string => {
  if (!str) return '';

  // Replace special characters with spaces
  return (
    str
      // Replace hyphens, underscores, and dots with spaces
      .replace(/[-_.]/g, ' ')
      // Insert space before capital letters that follow lowercase letters
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // But don't add spaces between consecutive capital letters followed by lowercase
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      // Split by spaces, capitalize each word's first letter, and join back
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
};
